export default "__VITE_ASSET__ef728ec9__"